import React from "react";
import { useLiff } from "react-liff";
import { useNavigate } from "react-router-dom";

import file from "../../assets/images/icon/file-white.svg";
import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import PrimaryButton from "../../components/button/PrimaryButton";
// import background from '../../assets/images/bg-info.png';
import { SearchCampaignDetail } from "../../services/LuckyDraw";
import TopLuckyDraw from "../../components/layout/TopLuckyDraw"
import GrayButton from "../../components/button/GrayButton";
import { useDispatch, useSelector } from 'react-redux';
import { setLuckyDraw } from "../../features/LuckyDrawSlice";

export default function LuckyDrawMain() {

  const store = useSelector((state) => state.luckyDraw)
  // const bg = store['bgPicture']
  // const banner = store['logoPicture']
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [campaign, setCampaign] = React.useState({
    condition: []
  });
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  React.useEffect(() => {
    getSearchCampaignDetail()
  }, []);

  async function getSearchCampaignDetail() {
    return await SearchCampaignDetail({ data: { lineId: lineId, campaignId: store.campaignId } })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          setCampaign(response.data.body)
          fnSetData('campaignId', store.campaignId)
          fnSetData('campaignName', response.data.body.campaignName)
          fnSetData('campaignUsed', response.data.body.campaignUsed)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setLuckyDraw(tmpObj));
  }


  return (
    <div id="shop-page">
      <TopLogo />
      {/* <TopBanner type="luckyDraw" img={banner} /> */}
      {/*<img src={ShopBanner} alt="shopbanner" className="w-full" />*/}
      <div id="shop"
        style={{
          background: `url(${store['bgPicture']}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          backgroundSize: "cover"
        }}
        className="px-[20px]">
        <TopBanner type="luckyDraw" img={store['logoPicture']} />
        <div className="relative">
          <TopLuckyDraw campaignUsed={campaign.campaignUsed} campaignName={campaign.campaignName} ishaveReward={campaign.haveReward}></TopLuckyDraw>
          <div className="bg-white rounded-[16px] mt-[-35px] mb-[80px] px-[20px] pt-[30px]" style={{ width: "90%", marginLeft: "5%", marginRight: "5%" }}>

            <GrayButton className="w-full" onClick={() => navigate('/lucky-draw-history', {
              state: { campaignId: store.campaignId }
            })} >ประวัติการลงทะเบียน / ตรวจสอบสถานะ</GrayButton>
            <div className="text-center text-lightblue text-[20px] mt-[10px]"> {campaign.campaignDetails} </div>
            {/* <div className="text-center text-lightblue text-[20px] mt-[10px]"> ลุ้นรับโชค Lucky Draw ด้วยขั้นตอนต่อไปนี้ </div> */}

            {campaign && campaign.condition.length > 0 &&
              campaign.condition.map((item, index) => (
                <div key={index}>
                  <div className="grid gap-[20px] mt-[10px]" style={{ gridTemplateColumns: "1fr 5fr" }}>
                    <div className="ml-[10px] w-fit h-fit my-auto mx-auto">
                      <img className="w-full" style={{ minWidth: "20px" }} src={item.conditionPicture} alt="" />
                    </div>
                    <div>
                      <p className="secondary-color text-[16px] leading-[16px]">{item.conditionName}</p>
                      <p className="text-[16px] leading-[16px] whitespace-pre-line">{item.conditionDetail}</p>
                    </div>
                  </div>
                </div>
              ))
            }

            {/* <div>
              <div className="grid gap-[20px] mt-[10px]" style={{ gridTemplateColumns: "1fr 5fr" }}>
                <div className="ml-[10px] w-fit h-fit my-auto mx-auto">
                  <img className="w-full" style={{ minWidth: "20px" }} src={lucky1} alt="" />
                </div>
                <div>
                  <p className="secondary-color text-[16px] leading-[16px]">ขั้นตอนที่ 1</p>
                  <p className="text-[16px] leading-[16px] whitespace-pre-line">กดติดตาม Facebook Haier Thailand : https://www.facebook.com/HaierThailand​</p>
                </div>
              </div>
            </div>
            <div>
              <div className="grid gap-[20px] mt-[10px]" style={{ gridTemplateColumns: "1fr 5fr" }}>
                <div className="ml-[10px] w-fit h-fit my-auto mx-auto">
                  <img className="w-full" style={{ minWidth: "20px" }} src={lucky2} alt="" />
                </div>
                <div>
                  <p className="secondary-color text-[16px] leading-[16px]">ขั้นตอนที่ 2</p>
                  <p className="text-[16px] leading-[16px] whitespace-pre-line">ซื้อสินค้าไฮเออร์ที่ร่วมรายการเพื่อสะสมสิทธิ์ Lucky Draw ผ่านช่องทาง Lazada Haier Official Store : https://www.lazada.co.th/shop/haier
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="grid gap-[20px] mt-[10px]" style={{ gridTemplateColumns: "1fr 5fr" }}>
                <div className="ml-[10px] w-fit h-fit my-auto mx-auto">
                  <img className="w-full" style={{ minWidth: "20px" }} src={lucky3} alt="" />
                </div>
                <div>
                  <p className="secondary-color text-[16px] leading-[16px]">ขั้นตอนที่ 3</p>
                  <p className="text-[16px] leading-[16px] whitespace-pre-line">ส่งหลักฐานคำสั่งซื้อที่สมบูรณ์แล้ว พร้อมกับให้เห็นหมายเลขคำสั่งซื้อ วัน-เวลาที่ซื้อและชำระสินค้า มาลงทะเบียนที่ LINE OA @haierthailand</p>
                </div>
              </div>
            </div> */}

            <div className="mt-10 px-[10px]">
              <p className="text-[12px]">หมายเหตุ</p>
              <div className="text-[12px] whitespace-pre-line">{campaign.note ? campaign.note : '-'}</div>
            </div>

            {/* <div className="mt-10 px-[10px]">
              <p className="text-[12px]">หมายเหตุ</p>
              <div className="text-[12px] whitespace-pre-line">
                🚪 ประตูแห่งกาลเวลาพร้อมแล้ว! ที่จะเปิดรับผู้ร่วมเล่นสนุกไปกับความทรงจำแห่งยุคทองของวัยเก๋า 😎​ <br></br>
                🌈 ไฮเออร์ชวนมาร่วมลุ้นเป็น 1 ใน 10 ผู้โชคดีที่จะได้เข้าร่วมชมไลฟ์อย่างใกล้ชิดกับ เจมีไนน์ นรวิชญ์ ในกิจกรรม Haier Dream For Fan SS4 ตอน “Haier Rewind 90’s With Gemini เปิดห้องวาร์ป ย้อนเวลาไลฟ์ Vibe 90" 💗​ <br></br>
                🥳 รายละเอียดวิธีการร่วมสนุก​ <br></br>
                1. กดติดตาม Facebook Haier Thailand : https://www.facebook.com/HaierThailand​ <br></br>
                2. ซื้อสินค้าไฮเออร์ที่ร่วมรายการเพื่อสะสมสิทธิ์ Lucky Draw ผ่านช่องทาง Lazada Haier Official Store : https://www.lazada.co.th/shop/haier​ <br></br>
                3. ส่งหลักฐานคำสั่งซื้อที่สมบูรณ์แล้ว พร้อมกับให้เห็นหมายเลขคำสั่งซื้อ วัน-เวลาที่ซื้อและชำระสินค้า มาลงทะเบียนที่ LINE OA @haierthailand : https://lin.ee/6P934Ax ตามขั้นตอนดังนี้​ <br></br>
                (1) เลือกเมนู Activities บน LINE Rich Menu​ <br></br>
                (2) เลือกกิจกรรม Haier Rewind 90’s With Gemini​ <br></br>
                (3) กรอกข้อมูลคำสั่งซื้อและอัปโหลดหลักฐานการสั่งซื้อให้ถูกต้องและครบถ้วน​ <br></br>
                (4) กดยืนยัน ​<br></br>
                (5) เจ้าหน้าที่จะใช้เวลา 2-3 วันทำการในการตรวจสอบข้อมูล คุณสามารถเช็คประวัติการลงทะเบียนและจำนวนสิทธิ์ได้ในหน้ากิจกรรม​ <br></br>
                4. สามารถซื้อสินค้าและลงทะเบียนสิทธิ์ได้ตั้งแต่วันที่ 18 พ.ค. - 18 มิ.ย. 2567 เวลา 23.59 น. เท่านั้น ​<br></br>
                5. สินค้าแต่ละชนิดมีจำนวนสิทธิ์ไม่เท่ากัน โปรดอ่านตารางเทียบจำนวนสิทธิ์โดยละเอียด​ <br></br>
                6. ประกาศรายชื่อผู้โชคดี จำนวน 10 ท่าน ในวันที่ 20 มิ.ย. 2567 เวลา 18.00 น. ผ่านทาง Facebook : Haier Thailand​ <br></br>
                หมายเหตุ​ <br></br>
                1. รายชื่อผู้โชคดี 1 ชื่อ-นามสกุล ต่อ 1 รางวัล เท่านั้น​ <br></br>
                2. กิจกรรมสามารถร่วมสนุกได้ตั้งแต่วันที่ 18 พ.ค. - 18 มิ.ย. 2567 เวลา 23.59 น. เท่านั้น <br></br>
                3. ในช่วงเวลากิจกรรม ราคาสินค้าอาจมีการปรับเปลี่ยนโดยขึ้นอยู่กับโปรโมชันเพิ่มเติมของช่องทางการขายนั้น ๆ​ <br></br>
                4. ขอสงวนสิทธิ์ชำระสินค้าผ่านบัตรเครดิต หรือ Internet Banking เท่านั้น กิจกรรมนี้ไม่สามารถสั่งซื้อแบบชำระเงินปลายทางได้ รวมถึงการยกเลิกการสั่งซื้อในทุกกรณี​ <br></br>
                5. ทีมงานจะคัดเลือกผู้ที่ส่งข้อมูลถูกต้องและชำระเงินเสร็จสมบูรณ์ภายในระยะเวลากิจกรรมตามที่กำหนดเท่านั้น​ <br></br>
                6. การซื้อสินค้าเพื่อร่วมลุ้นสิทธิ์ในกิจกรรม Haier Rewind 90’s With Gemini​ ไม่สามารถนับรวมสิทธิพิเศษหรือของรางวัลอื่นใดนอกเหนือจากที่ระบุเท่านั้น​ <br></br>
                7. ประกาศรายชื่อผู้โชคดี จำนวน 10 ท่าน ผ่านทาง Facebook : Haier Thailand ในวันที่ 20 มิ.ย. 2567 เวลา 18.00 น. โดยผู้โชคดีจะต้องยืนยันสิทธิ์ผ่านทาง Inbox Facebook : Haier Thailand ภายในวันที่ 22 มิ.ย. 2567 เวลา 18.00 น. เท่านั้น มิเช่นนั้นจะถือว่าท่านสละสิทธิ์​ <br></br>
                8. ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกฏ กติกา และของรางวัล โดยมิต้องแจ้งให้ทราบล่วงหน้า​ <br></br>
                9. รางวัลไม่สามารถแลกเปลี่ยนเป็นเงินสดหรือโอนสิทธิ์ให้แก่ผู้อื่นในทุกกรณี​ <br></br>
                10. กรณีมีข้อพิพาทเกิดขึ้นให้ถือว่าหลักฐานและคำตัดสินของคณะกรรมการถือเป็นที่สิ้นสุด​ <br></br>
                #Haier #HaierThailand #HaierMoreCreationMorePossibilities #HaierDreamForFanSS4 #Gemini_NT #เจมีไนน์ #HaierRewind90sWithGemini

              </div>
            </div> */}
            <br></br>
          </div>

        </div>
      </div>
      <div className="bg-white w-full" style={{
        position: 'fixed',
        bottom: 0,
        padding: '20px'
      }}>
        <div className="place-content-center">
          <PrimaryButton
            fullWidth
            variant="contained"
            onClick={() => {
              fnSetData('productList', campaign.productList)
              navigate('/lucky-draw-form')
            }}
          >
            <img className="w-[18px]" src={file} alt="" />
            <p>ลงทะเบียน Lucky Draw</p>
          </PrimaryButton>
        </div>

      </div>
    </div>

  )
}